import { jsx } from "react/jsx-runtime";
import NumbersIcon from "@mui/icons-material/Numbers";
import { validateTidalLicense } from "../../base/index.js";
function Numbers(props) {
  return /* @__PURE__ */ jsx(
    NumbersIcon,
    {
      "data-testid": "Numbers",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Numbers",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Numbers.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Numbers"
};
validateTidalLicense();
export {
  Numbers
};
//# sourceMappingURL=Numbers.js.map
